import { useControlPanel } from "@/features/control-panel/hooks/useControlPanel"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType as NewEventType } from "@/features/events/types/EventType"
import { useGetHealthPlan } from "@/features/health-plan/hooks/useGetHealthPlan"
import MealPlanPreview from "@/features/meal-plan/components/MealPlanPreview"
import { useGetMealPlans } from "@/features/meal-plan/hooks/useGetMealPlans"
import { useAuthStore } from "@/utils/stores/useAuthStore"
import { useEffect } from "react"
import ControlPanelWidget from "../../features/control-panel/components/ControlPanelWidget"
import HealthPlanPreview from "../../features/health-plan/components/HealthPlanPreview"
import { saveEvent } from "../../utils/apis/user-service"
import { EventType } from "../../utils/enums/EventType"
import { useUserStore } from "../../utils/stores/useUserStore"
import ControlPanel from "./components/ControlPanel"

const HomePage = () => {
  const { auth } = useAuthStore()
  const userId = auth.userId
  const { sendEvent } = useCreateEvent()
  const { userData } = useUserStore()
  const email = userData.email
  const { refetch, healthPlans } = useGetHealthPlan()
  const { refetch: refetchMealPlans, mealPlans } = useGetMealPlans()

  const { isControlPanelAvailable } = useControlPanel()

  useEffect(() => {
    if (!email) return

    saveEvent(email, EventType.PageView, () => { }, () => { }, "home_page")

    void sendEvent({
      event: NewEventType.PAGE_VIEW,
      sub_category: "home_page",
    })

  }, [])

  useEffect(() => {
    refetch()
    refetchMealPlans()
  }, [])

  // ********************************************************************************

  if (isControlPanelAvailable) {
    return (
      <div className="w-full h-full flex flex-col">
        <div className="flex-1 space-y-xl">
          <ControlPanelWidget />
          {
            userId !== "17709960-4626-4244-897a-d3107d7f88d7" && healthPlans && healthPlans.length > 0 && <HealthPlanPreview healthPlan={healthPlans[0]} />
          }
          {
            userId === "17709960-4626-4244-897a-d3107d7f88d7" && mealPlans &&
            <div className="pb-[100px]">
              <MealPlanPreview mealPlan={mealPlans[0]} healthPlan={healthPlans ? healthPlans[0] : null} />
            </div>
          }
        </div>
      </div>
    )
  }

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex-1 space-y-[20px] w-full max-w-[1068px]">
        <ControlPanel />
        {
          healthPlans && <HealthPlanPreview healthPlan={healthPlans[0]} />
        }
      </div>
    </div>
  )
}

export default HomePage
